import React from 'react'
import styled, { css } from 'styled-components'
import breakpoints from '../../../vars/breakpoints'
import gutters from '../../../vars/gutters'
import colors from '../../../vars/colors'

export const MapHeroWrapper = styled.div`
  padding: 0 20px;
  position: relative;

  .p4paa-logo {
    display: block;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    width: 50%;
    z-index: 10;

    @media (min-width: ${breakpoints['bp-mobile']}) {
      width: 50%;
    }

    @media (min-width: ${breakpoints['bp-desktop']}) {
      width: 20%;
      margin-left: auto;
      margin-right: 20px;
      position: relative;
      top: 40px;
    }

    .across-america {
      display: none;
    }
  }

  .map-hero__mobile-map {
    margin-top: -40%;
    max-width: 100%;
    outline: none;

    &:focus {
          box-shadow: 0px 0px 15px 5px ${colors['faint-grey']};
    }

    @media (min-width: ${breakpoints['bp-desktop']}) {
      display: none;
    }
  }

  .map-wrapper {
    height: 0;
    margin-top: -16%;
    padding: 0;
    padding-bottom: 66.66666%;
    position: relative;
    width: 100%;

    .tooltip {
      background-color: ${colors['peacock-blue']};
      color: ${colors['white']};
      display: none;
      padding: 10px;
      pointer-events: none;
      position: absolute;
      text-align: center;
      text-transform: uppercase;
      z-index: 10;

      @media (min-width: ${breakpoints['bp-tablet']}) {
        display: block;
      }

      &:after {
        content: '';
        position: absolute;
        left: calc(50% - 5px);
        top: 100%;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid ${colors['peacock-blue']};
      }

      span {
        display: block;
      }
    }

    .tooltip--paved {
      span {
        &:nth-of-type(1) {
          font-family: "OneDotExt";
          font-size: .5rem;
          margin-bottom: 5px;
        }

        &:nth-of-type(2) {
          font-family: "OneDotCd";
          font-size: 1rem;
          letter-spacing: 1px;
        }
      }
    }

    .tooltip--not-paved,
    .tooltip--coming-soon {
      max-width: 140px;

      span {
        &:nth-of-type(1) {
          font-family: "OneDotCd";
          font-size: 1rem;
          letter-spacing: 1px;
          margin-bottom: 5px;
        }

        &:nth-of-type(2) {
          font-family: "OneDotExt";
          font-size: .5rem;
          line-height: 1.25;
        }
      }
    }
  }

  .map-hero__desktop-map {
    display: none;

    @media (min-width: ${breakpoints['bp-desktop']}) {
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 90%;
    }

    #USA {
      &:hover {
        .paved,
        .upcoming,
        .tag {
          fill: ${colors['light-grey']};

          &.hovered {
            fill: ${colors['lipstick']};
          }
        }
      }

      .paved {
        fill: ${colors['lipstick']};
        position: relative;

        &:hover {
          &.hovered {
            fill: ${colors['lipstick']};
          }
        }
      }

      .upcoming {
        fill: ${colors['dark-red']};

        &:hover {
          &.hovered {
            fill: ${colors['lipstick']};
          }
        }
      }

      .not-paved {
        cursor: pointer;

        &:hover {
          &.hovered {
            fill: ${colors['medium-grey']};
          }
        }
      }
    }
  }
`

export const LangToggles = styled.div`
  margin-bottom: 10px;
  margin-top: 60px;
  position: relative;
  text-align: right;
  z-index: 5;
  @media (min-width: ${breakpoints['bp-mobile']}) {
      margin-right: 1rem;
      margin-top: 90px;
  }
  p {
      display: inline-block;
      font: 400 13.3333px Arial;
      font-size: 12px;
      margin-right: 5px;
  }
  button {
      background-color: transparent;
      border: none;
      color: ${colors['lipstick']};
      outline: none;
      padding: 15px 10px;

      &:hover,
      &:focus {
          text-decoration: underline;
      }
  }
`

export const StateInfo = styled.div`
  opacity: ${props => props.displayStateInfo ? 1 : 0};
  position: absolute;
  right: 40px;
  top: 41%;
  transform: ${props => props.displayStateInfo ? 'translateY(0)' : 'translateY(1rem)'};
  transition: opacity .5s ease-out,
              transform .5s ease-out;
`

export const MapLocation = styled.p`
  font-family: 'OneDotCd';
  font-size: 4rem;
  font-weight: bold;
  margin-bottom: 15px;
  max-width: 360px;
  text-transform: uppercase;
  text-align: right;

  .map-data-city {
    color: ${colors['lipstick']};
    left: -10px;
    position: relative;
    z-index: 1;
  }

  .map-data-state {
    color: ${colors['faint-grey']};
    font-size: 6rem;
    position: absolute;
    right: -10px;
    top: -40px;
  }
`

export const MapLocationStats = styled.div`
  font-family: 'OneDotExt';
  text-align: right;
  text-transform: uppercase;

  .map-stats__number {
    color: ${colors['peacock-blue']};
    display: block;
    font-size: 3rem;
    margin-bottom: 3px;
    opacity: 1;
    transition: opacity .2s ease-out;

    &:empty {
      opacity: 0;
    }
  }

  .map-stats__text {
    color: ${colors['medium-grey']};
    display: block;
    font-size: .625rem;
    font-weight: bold;
    margin-bottom: 15px;
    opacity: 1;
    transition: opacity .2s ease-out;

    &:empty {
      opacity: 0;
    }
  }

  .map-stats__date {
    color: ${colors['peacock-blue']};
    display: block;
    font-size: 1.5rem;
    margin-bottom: 5px;
    opacity: 1;
    transition: opacity .2s ease-out;

    &:empty {
      opacity: 0;
    }
  }
`

export const NotPaved = styled.div`
  font-family: 'OneDotExt';
  font-size: .875rem;
  line-height: 1.25;
  position: absolute;
  right: 0;
  text-align: center;
  text-transform: uppercase;
  width: 250px;

  p {
    margin-bottom: 20px;

    span {
      text-align: right;
    }
  }

  strong {
    color: ${colors['peacock-blue']};
    display: block;
    margin-bottom: 10px;
  }
`

export const ComingSoon = styled.div`
  font-family: 'OneDotExt';
  font-size: .875rem;
  line-height: 1.25;
  position: absolute;
  right: 0;
  text-align: right;
  text-transform: uppercase;
  width: 260px;

  .map-stats__date {
    color: ${colors['peacock-blue']};
    display: block;
    font-size: 1.5rem;
    margin-bottom: 0;
  }

  .map-stats__text {
    color: ${colors['medium-grey']};
    display: block;
    font-size: .75rem;
    font-weight: bold;
    margin-bottom: 15px;
  }
`

export const CampaignIntroWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: -60%;
    padding: 0 20px;
    position: relative;

    @media (min-width: ${breakpoints['bp-mobile']}) {
        max-width: 45%;
        margin-left: auto;
        margin-top: -70%;
        text-align: right;
    }

    @media (min-width: ${breakpoints['bp-tablet']}) {
      max-width: 33.33333%
    }

    @media (min-width: ${breakpoints['bp-desktop']}) {
        bottom: 20%;
        margin: 0;
        padding: 0;
        max-width: 270px;
        position: absolute;
        right: 20px;
    }

    @media (min-width: ${breakpoints['bp-desktop-l']}) {
        bottom: 25%;
    }

    .copy {
        color: ${colors['medium-grey']};
        font-family: 'OneDotExt';
        font-size: .625rem;
        font-weight: bold;
        line-height: 1.5;
        position: relative;
        margin-bottom: 40px;
        max-width: 700px;
        text-transform: uppercase;
        z-index: 1;
        @media (max-width: ${breakpoints['bp-mobile']}) {
            font-size: 14px;
            margin-top: 5px;
        }
    }
    .eyebrow {
        bottom: 100%;
        line-height: 1;
        width: 100%;
        z-index: 2;

        h1 {
            font-size: ${(props) => props.lang.match(/^en/) ? '36px' : '30px'};
            letter-spacing: 1.5px;
            margin-bottom: 10px;
            max-width: 320px;
            width: 100%;
            @media (min-width: ${breakpoints['bp-mobile']}) {
                margin-left: auto;
            }
            @media (min-width: ${breakpoints['bp-tablet']}) {
                font-size: 40px;
                max-width: none;
            }
            @media (min-width: ${breakpoints['bp-desktop']}) {
                max-width: 520px;
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/modules/MapHero/styled-components.js